import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'

import { ActionBar } from './action-bar'
import { RevenueTable } from './revenue-table'

export const RevenuePlanningTab = props => {
  const revenueTableRef = useRef()

  const { activeTab, hideHeader } = props
  const [selectedLOB, setLOB] = useState({ label: 'All LOB', value: '' })
  const [hideEdit, setHideEdit] = useState(false)
  const [invalidList, setInvalidList] = useState({})

  useEffect(() => {
    if (revenueTableRef.current) {
      setHideEdit(activeTab === '3' && revenueTableRef.current.isRevenueAllocationEmpty())
    }
  }, [revenueTableRef.current])

  const handleInvalid = values => {
    setInvalidList(values)
  }

  return (
    <Root>
      <ActionBar
        { ...props }
        hideEdit={ hideEdit }
        invalidList={ invalidList }
        selectedLOB={ selectedLOB }
        setLOB={ setLOB }
      />
      <RevenueTable
        { ...props }
        ref={ revenueTableRef }
        hideHeader={ hideHeader }
        selectedLOB={ selectedLOB }
        invalidList={ invalidList }
        handleInvalid={ handleInvalid }
      />
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F1F1F1;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/index.js